<template>
  <div class="animate__animated animate__fadeIn">
    <h4>Edição de atividade</h4>
    <b-alert v-if="erro" show variant="danger">{{ erro }}</b-alert>
    <form @submit.prevent="submit">
      <div class="row">
        <form-input v-model="form.atividade" label="Atividade:" required />
        <form-input v-model="form.frequencia" label="Frequência:" grid="6" required />
        <form-input v-model="form.local" label="Local da atividade:" grid="6" required />
        <form-input v-model="form.objetivo" label="Objetivo:" required />
        <form-input v-model="form.data_atividade" label="Data:" grid="6" type="date" required />
        <form-input v-model="form.hora_atividade" label="Hora:" grid="6" type="time" required />
        <form-select v-model="form.status" label="Status:" grid="6" :itens="statusOptions"/>
        <div v-if="form.status !== statusOriginal" class="col-12 form-group">
          <label for="motivo-alteracao-atividade-crianca">Motivo da alteração de status (opcional):</label>
          <textarea id="motivo-alteracao-atividade-crianca" v-model="motivoAlteracao"
            class="form-control" rows="3"></textarea>
        </div>
      </div>
      <div class="d-flex flex-wrap justify-content-end">
        <b-button type="button" size="sm" variant="secondary" class="mr-2 mb-2"
          :disabled="salvando" @click="$emit('voltar')">Voltar</b-button>
        <b-button type="button" size="sm" variant="secondary" class="mr-2 mb-2"
          @click="alternarHistorico"><i class="fas fa-history"></i> Histórico de status</b-button>
        <b-button type="submit" size="sm" variant="success" class="mr-2 mb-2" :disabled="salvando">
          {{ salvando ? 'Salvando...' : 'Editar informações' }}
        </b-button>
        <b-button type="button" size="sm" variant="primary" class="mb-2"
          title="Visualizar e imprimir" @click="imprimirAtividade">
          <i class="mdi mdi-printer mdi-18px"></i>
        </b-button>
      </div>
    </form>

    <div v-if="historicoStatus" class="mt-4">
      <h5 class="mb-3">Histórico de status da atividade</h5>
      <b-alert v-if="erroHistorico" show variant="danger">{{ erroHistorico }}</b-alert>
      <load v-if="carregandoHistorico" mode="table" />
      <div v-else class="table-responsive">
        <table class="table table-striped table-bordered">
          <thead class="bg-primary text-white">
            <tr><th>Status anterior</th><th>Status atual</th><th>Motivo</th>
              <th>Alterado por</th><th>Data da alteração</th></tr>
          </thead>
          <tbody>
            <tr v-for="registro in historico" :key="registro.id">
              <td>{{ registro.status_anterior || '-' }}</td>
              <td>{{ registro.status_atual || '-' }}</td>
              <td class="texto-multilinha">{{ registro.motivo_finalizacao || '-' }}</td>
              <td>{{ registro.nome_usuario || '-' }}</td>
              <td>{{ formatarHistorico(registro.created_at) }}</td>
            </tr>
            <tr v-if="!historico.length && !erroHistorico">
              <td colspan="5" class="text-center">Nenhuma alteração de status registrada.</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-end">
        <b-button type="button" size="sm" variant="secondary" @click="historicoStatus = false">
          Fechar histórico
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { API, ROTA_IMPRESSAO, opcoesStatus, dataApi, horaApi,
  formatarHistorico, mensagemErro, notificar } from './apoioAtividadesCrianca';

export default {
  props: {
    item: { type: Object, required: true },
    atividade: { type: Object, required: true },
  },
  data() {
    return {
      form: {},
      statusOriginal: '',
      motivoAlteracao: '',
      statusOptions: opcoesStatus(),
      salvando: false,
      erro: '',
      historicoStatus: false,
      carregandoHistorico: false,
      erroHistorico: '',
      historico: [],
    };
  },
  watch: {
    atividade: {
      immediate: true,
      handler(valor) { this.preencherForm(valor); },
    },
  },
  methods: {
    formatarHistorico,
    preencherForm(atividade) {
      this.form = {
        ...atividade,
        data_atividade: dataApi(atividade.data_atividade),
        hora_atividade: horaApi(atividade.hora_atividade),
      };
      this.statusOriginal = atividade.status;
      this.motivoAlteracao = '';
    },
    imprimirAtividade() {
      if (!this.form.id) return;
      this.$router.push({ name: ROTA_IMPRESSAO, params: { id: this.form.id } });
    },
    alternarHistorico() {
      this.historicoStatus = !this.historicoStatus;
      if (this.historicoStatus) this.carregarHistorico();
    },
    async carregarHistorico() {
      this.carregandoHistorico = true;
      this.erroHistorico = '';
      this.historico = [];
      try {
        const response = await axios.get(`${API}/${this.form.id}/historico`);
        this.historico = response.data || [];
      } catch (erro) {
        this.erroHistorico = mensagemErro(erro, 'Erro ao carregar histórico de status.');
      } finally {
        this.carregandoHistorico = false;
      }
    },
    async submit() {
      if (this.salvando) return;
      this.erro = '';
      const obrigatorios = ['atividade', 'frequencia', 'local', 'objetivo',
        'data_atividade', 'hora_atividade', 'status'];
      if (obrigatorios.some(campo => !String(this.form[campo] || '').trim())) {
        this.erro = 'Preencha todos os campos obrigatórios.';
        return;
      }
      this.salvando = true;
      const payload = {
        acolhimento_id: this.item.id,
        atividade: this.form.atividade,
        frequencia: this.form.frequencia,
        local: this.form.local,
        objetivo: this.form.objetivo,
        data_atividade: dataApi(this.form.data_atividade),
        hora_atividade: horaApi(this.form.hora_atividade),
        status: this.form.status,
      };
      if (this.form.status !== this.statusOriginal) {
        payload.motivo_finalizacao = this.motivoAlteracao || null;
      }
      try {
        const response = await axios.post(`${API}/update/${this.form.id}`, payload);
        this.preencherForm(response.data.atividade);
        this.$emit('atualizado', response.data.atividade);
        notificar(this, 'success', 'Atividade atualizada com sucesso!');
        if (this.historicoStatus) await this.carregarHistorico();
      } catch (erro) {
        this.erro = mensagemErro(erro, 'Erro ao salvar a atividade.');
        notificar(this, 'warning', this.erro);
      } finally {
        this.salvando = false;
      }
    },
  },
};
</script>

<style scoped>
.texto-multilinha { white-space: pre-wrap; }
</style>
